/**
 * Section: product-tabs
 *
 * Desktop: Alpine.js controls tab visibility via x-show.
 * Mobile:  Swiper.js carousel with pagination dots.
 *
 * Uses matchMedia to conditionally init/destroy Swiper at the 750px breakpoint.
 */
if (!customElements.get('product-tabs-component')) {
  customElements.define(
    'product-tabs-component',
    class ProductTabsComponent extends HTMLElement {
      swiper = null;
      mql = window.matchMedia('(max-width: 749px)');

      connectedCallback() {
        this.onMediaChange = this.onMediaChange.bind(this);
        this.mql.addEventListener('change', this.onMediaChange);

        if (this.mql.matches) {
          this.initSwiper();
        }
      }

      disconnectedCallback() {
        this.mql.removeEventListener('change', this.onMediaChange);
        this.destroySwiper();
      }

      onMediaChange(event) {
        if (event.matches) {
          this.initSwiper();
          return;
        }

        this.destroySwiper();
      }

      initSwiper() {
        if (!window.Swiper) {
          return;
        }

        if (this.swiper) {
          return;
        }

        const sectionId = this.dataset.sectionId;
        const carouselEl = this.querySelector(`#product-tabs-swiper-${sectionId}`);

        if (!carouselEl) {
          return;
        }

        this.swiper = new window.Swiper(carouselEl, {
          slidesPerView: 1,
          spaceBetween: 20,
          pagination: {
            el: carouselEl.querySelector('.product-tabs__pagination'),
            clickable: true,
          },
          watchOverflow: true,
        });
      }

      destroySwiper() {
        if (!this.swiper) {
          return;
        }

        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    },
  );
}
